import dayjs from "dayjs";

export function formatDate(dateToFormat: string) {
  try {
    if (!dayjs(dateToFormat).isValid()) throw new Error();

    return dayjs(dateToFormat).format(`DD/MM/YYYY - HH:mm:ss`);
  } catch (error) {
    return `--/--/---- --:--:--`;
  }
}
